/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * Type of transaction
 */
export enum EarningsDataPointType {
  BOOKING = 'BOOKING',
  CANCELLATION = 'CANCELLATION'
}
